export const branches = [
    {
      id: 1,
      name: "Skyford Aviation",
      address: "Emarald Mall, Mavoor Road, Calicut - 673004",
      city: "Calicut",
      phone:"+91 81389 22115",
    //   coordinates: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3913.0242468635183!2d75.78919909999999!3d11.2596265!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba659216eaa1b33%3A0x6f052b039f0e2305!2sSkyford%20Aviation%20Academy!5e0!3m2!1sen!2sin!4v1736716312330!5m2!1sen!2sin",
      isMain: true
    },
    {
      id: 2,
      name: "Skyford Tower",
      // address: "Skyford Tower Balan K Nair Road Cherooty Nagar, Calicut - 673004",
      address: "Balan K Nair Road, Cherooty Nagar, Calicut - 673006",
      city: "Calicut",
      phone:"+91 98477 52211"
    //   coordinates: { lat: 11.2580098, lng: 75.7801562 }
    },

    {
      id: 3,
      name: "Skyford Aviation",
      // address: "Christian College Junction Wayanad Road, Calicut - 673004",
      address:"Near Malabar Christian college, Calicut-673001", //V2 LATEST ADDRESS
      city: "Calicut",
      phone:'+91 98953 32211',
    //   coordinates: { lat: 11.2729736, lng: 75.7868396 }
    },

    {
      id: 4,
      name: "Skyford Aviation",
      // address: "Near Valanjabalam, Chittoor Road, Cochin - 682016",
      address:"Wisdom Center, Chittoor Road, Cochin - 682016",
      city: "Cochin",
      phone:"+91 95674 22211",
    //   coordinates: { lat: 9.9661932, lng: 76.2882744 }
    },

    {
      id: 5,
      name: "Skyford Aviation",
      // address: "Near Valanjabalam, Chittoor Road, Cochin - 682016",
      address:"Near Valanjabalam, Chittoor Road, Cochin - 682016",
      city: "Cochin",
      phone:"+91 95674 22211",
    //   coordinates: { lat: 9.9661932, lng: 76.2882744 }
    },
    {
      id: 6,
      name: "Skyford Aviation",
      // address: "Opp GGHSS Chittoor Road, Cochin - 682016",
      address: "Near GGHSS, Chittoor Road, Cochin - 682016",
      city: "Cochin",
      phone:"+91 95674 22211",
    //   coordinates: { lat: 9.9674936, lng: 76.2891937 }
    },
    {
      id: 7,
      name: "Skyford Aviation",
      // address: "7th Floor, Capital City, (Behind Kalyan Silks) Round North, Thrissur - 682680", //⚠️ OLD ADDRESS
      address: "7th Floor, Capital City,  Round North, Thrissur - 682680",
      phone: "+91 90746 41161",
      city: "Thrissur",
    //   coordinates: { lat: 10.5276416, lng: 76.2144349 }
    },
    {
      id: 8,
      name: "Skyford Aviation",
      // address: "2nd Floor, Lido Mall, Thazhepalam, Tirur - 676101",
      address: "Lido Mall, Thazhepalam, Tirur - 676101",
      phone: "+91 95673 12211",
      city: "Tirur",
    //   coordinates: { lat: 10.5276416, lng: 76.2144349 }
    },
    {
      id: 9,
      name: "Skyford Aviation",
      // address: "2nd Floor, Lido Mall, Thazhepalam, Tirur - 676101",
      // address: "Lido Mall, Thazhepalam, Tirur - 676101",
      address:"Kalakappara Tower, Gov Hospital Junction, Perinthalmanna - 679322",
      phone: "+91 81293 12211",
      city: "Perinthalmanna",
    //   coordinates: { lat: 10.5276416, lng: 76.2144349 }
    }
  ];
  
  export const commonContact = {
    email: "admin@skyfordaviation.in",
    phone: "+91 98953 32211"
  };